import React from "react";
// used for making the prop types of this component
import PropTypes from "prop-types";

import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  CardFooter,
  Table,
  Row,
  Input,
  Col,
  Form,
  FormGroup,
  Label
} from "reactstrap";
import Select from "react-select";
import { thead } from "variables/general";
import { Link } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";
import { PanelHeader, Button, Statistics, Timeline } from "components";
import axios from "axios";
// import CKEditor from '@ckeditor/ckeditor5-react';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { Select as AntdSelect, Space, DatePicker, Button as ModalButton, Modal, TimePicker } from "antd";
import { Avatar, Card as LoadingCard, Skeleton, Switch } from 'antd';
const { Meta } = Card;

const ESTADO_FACTURA = "estado-factura";
var noteType = [
  { value: "59", label: "General" },
  { value: "60", label: "Incidencia" },
  { value: "62", label: "Log" },
  { value: "61", label: "Solución" },
  { value: "214", label: "Devolución" }
  /*,
  { value: "three", label: "Baja" },
  { value: "four", label: "Suspensión por impago" },
  { value: "five", label: "Cambio de nombre" },
  { value: "six", label: "Cambio de tarifa" }*/
];

class BillsTable extends React.Component {
  constructor(props) {
    super(props);
    // console.log("Dentro de BillsTable -> this.props", props);
    this.state = {
      bills: this.props.bills,
      showCustomer: this.props.showCustomer,
      userData: this.props.userData,
      showItems: null,
      showNotes: null,
      registerPayment: null,
      showNoteForm: false,
      noteType: null,
      noteTitle: "",
      noteText: null
    };
    this.createOrdersTable = this.createOrdersTable.bind(this);
    this.paymentStatus = this.paymentStatus.bind(this);
    this.openBillStatusPopUpFromBill = this.openBillStatusPopUpFromBill.bind(this);
    this.showPopUp = this.showPopUp.bind(this);
    this.createBillStatusPopUp = this.createBillStatusPopUp.bind(this);
    this.getViewArticlesButton = this.getViewArticlesButton.bind(this);
    this.validateNote = this.validateNote.bind(this);
    this.clearNote = this.clearNote.bind(this);
    this.newNote = this.newNote.bind(this);
    this.filterNotes = this.filterNotes.bind(this);
    this.hideAlert = this.hideAlert.bind(this);
    this.showPopUpConfirmation = this.showPopUpConfirmation.bind(this);
    this.hidePopUpConfirmation = this.hidePopUpConfirmation.bind(this);
    this.createRegisterPayment = this.createRegisterPayment.bind(this);
    this.newRegisterPayment = this.newRegisterPayment.bind(this);
    this.validateRegisterPayment = this.validateRegisterPayment.bind(this);
  }
  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!this.props.userData.mainState.isCreatingNote && prevProps.userData.mainState.isCreatingNote) {
      this.props.reloadEntityCallback(this.state.showNotes);
    }
  }
  showPopUpConfirmation(tipo) {
    switch (tipo) {
      case ESTADO_FACTURA:
        this.editBillStatusConfirmation();
        break;
      default:;
    }
  }
  hidePopUpConfirmation() {
    this.setState({
      popUpConfirmation: null
    });
  }
  editBillStatusConfirmation() {
    // console.log("this.props", this.props);
    // console.log("this.state", this.state);
    // return;
    this.props.userData.editBill(
      this.state.currentBillID,
      this.state.currentBillStatus.value,
      this.state.currentBill.cliente_id
    );
    this.setState({
      showPopUp: false,
      popUpConfirmation: (
        <SweetAlert
          success
          style={{ display: "block", marginTop: "-250px" }}
          title="¡Estado editado!"
          onConfirm={() => this.hidePopUpConfirmation()}
          onCancel={() => this.hidePopUpConfirmation()}
          confirmBtnBsStyle="default"
          confirmBtnText="Cerrar"
        >
          El estado ha sido editado.
        </SweetAlert>
      )
    });
  }
  paymentStatus(order){
    let statusReady = null;
    let payment = order.estado_pedido;
    let statusButtonColor = "default";
    let statusButtonIcon = "now-ui-icons ui-2_time-alarm";
    let isDisabled = false;
    if (payment.includes("Pendiente")) {
      statusButtonColor = "warning";
      statusButtonIcon = "now-ui-icons ui-2_time-alarm";
    } else if(payment.includes("Pagada")){
      statusButtonColor = "primary";
      statusButtonIcon = "now-ui-icons ui-1_check";
    } else if(payment.includes("Procesando")){
      statusButtonColor = "info";
      statusButtonIcon = "now-ui-icons arrows-1_refresh-69 spin";
    } else /*if(payment.includes("Recibo"))*/{
      statusButtonColor = "danger";
      statusButtonIcon = "now-ui-icons ui-1_simple-remove";
    }
    
    let editingBill = this.props.userData.mainState.editingBill;
    if (!editingBill) editingBill = [];
    editingBill = editingBill[order.order_id];

    if (editingBill) {
      statusButtonColor = "default";
      statusButtonIcon = "now-ui-icons arrows-1_refresh-69 spin";
      isDisabled = true;
    }

    statusReady = (
      <Button
        color={statusButtonColor}
        size="sm"
        disabled={isDisabled}
        onClick={() => this.openBillStatusPopUpFromBill(order) }
      >
        <i className={statusButtonIcon} /> {payment}
      </Button>
    );

    return statusReady;
  }
  openBillStatusPopUpFromBill(order) {
    // console.log("################## OPEN BILL STATUS ################");
    // console.log(order);
    let billID = order.order_id;
    let billStatus = order.estado_pedido;
    let billNumber = order.numero_pedido;
    let _currentBillStatus = null;
    this.props.userData.mainState.billStatuses.forOptions.map(currentStatus => {
      if (currentStatus.label === billStatus)
        _currentBillStatus = currentStatus;
    });
    this.setState({
      currentBillID: billID,
      currentBillStatus: _currentBillStatus,
      currentBillNumber: billNumber,
      currentBill: order
    });
    this.showPopUp(ESTADO_FACTURA);
  }
  showPopUp(tipo) {
    // console.log("######### OPCIONES ###########");
    // console.log(this.props.mainState);
    this.setState({
      popUpToShow: tipo,
      showPopUp: true,
      popUpConfirmation: null
    });
  }
  createPopUp() {
    // console.log("############# CREATING POPUP #############");
    // console.log(this.state);
    // console.log(this.props.mainState);
    switch (this.state.popUpToShow) {
      case ESTADO_FACTURA:
        return this.createBillStatusPopUp();
      default:
        //console.log("################## ERROR CREATE POPUP ################");
        //console.log("POPUP TO SHOW NOT SPECIFIED");
        return;
    }
  }
  createBillStatusPopUp() {
    return (
      <SweetAlert
        style={{ display: "block", marginTop: "-250px" }}
        title="Editar estado"
        onConfirm={() => this.showPopUpConfirmation(ESTADO_FACTURA)}
        onCancel={() => this.hideAlert()}
        confirmBtnBsStyle="primary"
        cancelBtnBsStyle="default"
        confirmBtnText="Guardar"
        cancelBtnText="Cancelar"
        showCancel
      >
        <Form className="form-horizontal">
          <Row>
            <Label md={3}>Estado</Label>
            <Col xs={12} md={9}>
              <FormGroup>
                <Select
                  className="react-select primary"
                  classNamePrefix="react-select"
                  placeholder="Estado"
                  name="estado"
                  value={this.state.currentBillStatus}
                  options={
                    this.props.userData.mainState.billStatuses.forOptions
                  }
                  onChange={value =>
                    this.setState({ currentBillStatus: value })
                  }
                />
                <br></br>
              </FormGroup>
            </Col>
          </Row>
        </Form>
      </SweetAlert>
    );
  }
  downloadBill(url, orderNumber, event){
    url = url.replace("mi-tienda", "oficina");
    this.setState({
      [orderNumber]: true
    });
    axios({
      url: url,
      method: 'GET',
      responseType: 'blob', // important
    }).then((response) => {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute(
        "download",
        "factura_nadunet_".concat(orderNumber).concat(".pdf")
      );
      document.body.appendChild(link);
      link.click();
      this.setState({
        [orderNumber]: false
      });
    });
  }
  downloadButton(order){
    let button = 
      <div>
        <i className="now-ui-icons arrows-1_cloud-download-93" /> PDF
      </div>;

    if(this.state[order]){
      button = 
        <div>
          <i className="now-ui-icons arrows-1_refresh-69 spin" />
        </div>;
    }

    return button;
  }
  getViewArticlesButton(order) {
    return null;
    let button = 
      <Button
        color="default"
        size="sm"
        /* onClick={e =>
          this.viewOrderArticles(order.numero_pedido, e)
        } */
      >
        <div>
          <i className="now-ui-icons arrows-1_refresh-69 spin" /> Ver
        </div>
      </Button>;

    if(true /*order in this.props.mainState.ordersArticles*/){
      button = 
      <Link to={"/facturas/".concat(order)}>
        <Button
          color="info"
          size="sm"
          /* onClick={e =>
            this.viewOrderArticles(order.numero_pedido, e)
          } */
        >
          <div>
            <i className="now-ui-icons education_glasses" /> Ver
          </div>
        </Button>
      </Link>;
    }

    return button;
  }
  validateRegisterPayment() {
    let result = true;
    try {
      if (!this.state.registerPaymentConcept || this.state.registerPaymentConcept.length < 1) result = false;
      if (!this.state.registerPaymentAmount || (this.state.registerPaymentConcept && this.state.registerPaymentConcept.length < 1)) result = false;
    } catch (error) {
      result = false;
    }
    return result;
  }
  filterNotes(note) {
    if (!this.state.noteFilter) return true;
    let note_text = note.texto;
    let noteFilter = this.state.noteFilter.toLowerCase();
    // console.log("note_text", note_text);
    try {
      let note_json = JSON.parse(note_text);
      // console.log("note_json", note_json);
      note_text = note_json.text;
    } catch (error) {
      // console.log("error", error);
      note_text = note.texto;
    }

    let subFilters = noteFilter.toLowerCase().split(" ");
    let result = true;
    if (!subFilters || subFilters.length === 0) {
      return result;
    }
    // console.log("subFilters",subFilters);
    subFilters.map(filter => {
      let localResult = false;
      // Si cualquiera de las condiciones se cumple, devuelve TRUE
      if (note_text.toLowerCase().includes(filter)) localResult = true;
      if (note.fecha.toLowerCase().includes(filter)) localResult = true;
      if (note.tipo.toLowerCase().includes(filter)) localResult = true;
      if (note_text.toLowerCase().includes(filter)) localResult = true;
      if (note.autor.toLowerCase().includes(filter)) localResult = true;
      if (note.titulo.toLowerCase().includes(filter)) localResult = true;

      result = result && localResult;
    });
    return result;
  }
  validateNote() {
    let result = true;
    if (!this.state.noteText || this.state.noteText.length < 1) result = false;
    if (!this.state.noteTitle || this.state.noteTitle.length < 1) result = false;
    if (!this.state.noteType) result = false;
    return result;
  }
  clearNote() {
    this.setState({
      noteText: "",
      noteTitle: "",
      noteType: null,
      showNoteForm: false
    });
  }
  newNote() {
    if (!this.validateNote()) {
      return;
    }
    //console.log("################## SHOW POP UP CONFIRMATION ################");
    //console.log(this.state);
    this.props.userData.createNote(
      this.state.noteType.value,
      this.state.noteTitle,
      this.state.noteText,
      this.state.showNotes
    );
    this.clearNote();
  }
  createNotesContent(notes) {
    try {
      let notesCardHeader = (
          <CardHeader className="txt-black">
            <h5>
              <i className="now-ui-icons design-2_ruler-pencil" /> Notas{"  "}
              <Button
                icon
                round
                key={"createNoteButton"}
                color="info"
                onClick={() => {
                  let showNoteForm = this.state.showNoteForm;
                  this.setState({ showNoteForm: !showNoteForm });
                }}
                leftLabel={"now-ui-icons " + (this.props.userData.mainState.isCreatingNote ? "arrows-1_refresh-69 spin reposition-spin" : "ui-1_simple-add")}
              />
            </h5>
            {this.state.showNoteForm && 
            <Card>
              <CardBody>
                <Form className="form-horizontal">
                  <Row>
                    <Label md={3}>Tipo</Label>
                    <Col xs={12} md={9}>
                      <FormGroup>
                        <Select
                          className="react-select primary"
                          classNamePrefix="react-select"
                          placeholder="Tipo de nota"
                          name="noteType"
                          value={this.state.noteType}
                          options={noteType}
                          onChange={value => this.setState({ noteType: value })}
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Label md={3}>Título</Label>
                    <Col xs={12} md={9}>
                      <FormGroup>
                        <Input
                          type="text"
                          name="noteTitle"
                          placeholder="Título de la nota"
                          value={this.state.noteTitle}
                          onChange={event =>
                            this.setState({ noteTitle: event.target.value })
                          }
                        />
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col size={12}>
                      <FormGroup>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={6}>
                      <Button
                        // icon
                        // round
                        disabled={!this.validateNote()}
                        style={{ width: "100%" }}
                        color="primary"
                        onClick={() => {
                          console.log("crear nota", this.state);
                          this.newNote();
                        }}
                        leftLabel={"now-ui-icons ui-1_simple-add"}
                      >
                        {"Crear"}
                      </Button>
                    </Col>
                    <Col xs={6}>
                      <Button
                        // icon
                        // round
                        style={{ width: "100%" }}
                        color="default"
                        onClick={() => {
                          this.clearNote();
                        }}
                        leftLabel={"now-ui-icons ui-1_simple-remove"}
                      >
                        {"Cancelar"}
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>}
          </CardHeader>
      );
      let notesCard = null;
      let notesCardBody = null;
      let customerNotes = notes.notes;
      if (!customerNotes) customerNotes = [];
      if (customerNotes.length > 0) {
        customerNotes = customerNotes.map((note, key) => {
          if (this.filterNotes(note)) {
            let badgeStyle = {
              color: "default",
              icon: "travel_info"
            };
            if (note.tipo === "Incidencia") {
              badgeStyle.color = "danger";
              badgeStyle.icon = "ui-2_settings-90";
            }
            if (note.tipo === "Solución") {
              badgeStyle.color = "primary";
              badgeStyle.icon = "ui-2_like";
            }
            if (note.tipo === "Log") {
              badgeStyle.color = "warning";
              badgeStyle.icon = "ui-1_bell-53";
            }
            if (note.tipo === "Pago") {
              badgeStyle.color = "primary";
              badgeStyle.icon = "business_money-coins";
            }
  
            let note_text = note.texto;
            // console.log("note_text", note_text);
            try {
              let note_json = JSON.parse(note_text);
              // console.log("note_json", note_json);
              note_text = note_json.text;
            } catch (error) {
              // console.log("error", error);
              note_text = note.texto;
            }
  
            note = {
              inverted: true,
              badgeColor: badgeStyle.color,
              badgeIcon: "now-ui-icons " + badgeStyle.icon,
              title: note.autor + (note.titulo !== "" ? ": " + note.titulo : ""),
              titleColor: "danger",
              body: <div dangerouslySetInnerHTML={{ __html: note_text }} />,
              footerTitle: <div dangerouslySetInnerHTML={{ __html: note.fecha }} />
            };
            return note;
          }
        });
        customerNotes = customerNotes.filter(function (el) {
          return el != null;
        });
        notesCardBody =
          <CardBody>
            <Row>
              <Col xs={12}>
                <FormGroup>
                    <Input
                      type="text"
                      className="note-filter"
                      placeholder="Filtrar notas..."
                      value={this.state.noteFilter || ""}
                      // onChange={e => this.handleChange("searchQuery", e)}
                      onChange={e => this.setState({ noteFilter: e.target.value })}
                      // onKeyDown={this.handleKeyDown}
                      // disabled={this.props.mainState.isSearchingBuildings}
                      // onKeyDown={e => {
                      //   //console.log(e.keyCode);
                      //   if (e.keyCode == 13) {
                      //     console.log("ola k ase?");
                      //     //Enter is key code 13
                      //     // this.searchCustomer();
                      //     // put the login here
                      //   }
                      // }}
                      // style={{ marginRight: "10px" }}
                    />
                </FormGroup>
              </Col>
            </Row>
            {this.state.showNotes && <Timeline stories={customerNotes} simple />}
            <Row>
              <Col xs={12}>
                <Card 
                  onClick={() => this.setState({ showNotes: !this.state.showNotes }) }
                  color="default" 
                  style={{ overflow: "hidden" }}
                  className="text-center building-card">
                  {customerNotes.length > 0 && <CardHeader className="txt-black">
                    <i className={this.state.showNotes ? "now-ui-icons ui-1_simple-delete" : "now-ui-icons ui-1_simple-add"} /> {
                    this.state.showNotes ? "Ocultar todas" : "Mostrar todas"
                  }
                  </CardHeader>}
                  <CardBody className="text-center txt-white h3 h-nomargin">
                    {customerNotes.length + (customerNotes.length === 1 ? " nota" : " notas")}
                  </CardBody>
                  <CardFooter className="text-right txt-black">
                    <Row>
                      <Col xs={6} className="text-left txt-black">
                        {/* Pulsa para mostrar todos */}
                      </Col>
                      <Col xs={6} className="text-right txt-black">
                        {/* {mobile.precio} */}
                      </Col>
                    </Row>
                  </CardFooter>
                  {/* {coverage} */}
                </Card>
              </Col>
            </Row>
          </CardBody>;
      } else {
        if (!notes.loaded) {
          if (!this.props.userData.mainState.isGettingOrder) this.props.reloadEntityCallback(this.state.showNotes);
          notesCardBody = 
            <CardBody>
              <div className="text-center">
                <i className="now-ui-icons arrows-1_refresh-69 spin" />{" Cargando notas..."}
              </div>
            </CardBody>;
        } else {
          notesCardBody = 
            <CardBody>
              <div>
                <i className="now-ui-icons ui-1_simple-remove" /> No hay notas
              </div>
            </CardBody>;
        }
      }
      notesCard = (
        <Card key="notesCard" className="card-plain card-timeline">
          {notesCardHeader}
          {notesCardBody}
        </Card>
      );
      return notesCard;
      
    } catch (error) {
      return "Error al crear las notas: " + error;
    }
  }
  hideAlert() {
    this.setState({
      showPopUp: false
    });
  }
  newRegisterPayment() {
    console.log("crear registro de pago");
    let registerPayment = {
      order: this.state.registerPayment,
      concept: this.state.registerPaymentConcept,
      amount: this.state.registerPaymentAmount
    };
    this.setState({ registeringPayment: true });
    this.props.userData.newRegisterPayment(registerPayment).then(result => {
      /* ////// console.log("################## RESPUESTA ################");
      ////// console.log(result); */
      let response = result;// result.data;
      if (response.ok) {
  
        let order = response.order;
        this.props.reloadEntityCallback(order.order_id, response.order);
        this.setState({ 
          registeringPayment: false,
          showItems: null,
          showNotes: null,
          registerPayment: null
        });
      } else {
        this.setState({ 
          registeringPayment: false
        });
        console.log("Error al registrar el pago", response.error);
      }
      // let state = this.state;
      // state.isGettingPaymentLink = false;
      // let response = result;// result.data;
      // if (response.result === "OK") {
      //   state.paymentLink = response.url;
      // } else {
      //   // this.showError(response.error);
      // }
      // this.setState(state);
    })
    .catch((error) => {
      // Error 😨
      this.setState({
        isGettingPaymentLink: false
      });
      // this.showError("Error al obtener el enlace, vuelve a intentarlo en un momento. (" + error + ")");
    });
  }
  createRegisterPayment() {
    return (
      <Form className="form-horizontal">
        <Row>
          <Col xs={5}>
            {/* <Label md={3}>Concepto</Label> */}
            <FormGroup>
              <Input
                type="text"
                name="registerPaymentConcept"
                placeholder="Concepto del pago"
                value={this.state.registerPaymentConcept}
                onChange={event => this.setState({ registerPaymentConcept: event.target.value })}
              />
            </FormGroup>
          </Col>
          <Col xs={5}>
            {/* <Label md={3}>Importe</Label> */}
            <FormGroup>
              <Input
                type="number"
                name="registerPaymentAmount"
                placeholder="Importe del pago"
                value={this.state.registerPaymentAmount}
                onChange={event => this.setState({ registerPaymentAmount: event.target.value })}
              />
            </FormGroup>
          </Col>
          <Col xs={2}>
            <Button
              color="primary"
              size="sm"
              disabled={!this.validateRegisterPayment() || this.state.registeringPayment}
              onClick={() => {
                this.newRegisterPayment();
                // let registerPayment = this.state.registerPayment;
                // if (registerPayment === order_id) {
                //   registerPayment = null;
                // } else {
                //   registerPayment = order_id;
                // }
                // this.setState({ 
                //   registerPayment: registerPayment,
                //   showNotes: null, 
                //   showItems: null,
                //   registerPaymentAmount: null,
                //   registerPaymentConcept: null
                // });
              }}
              leftLabel={this.state.registeringPayment ? "now-ui-icons arrows-1_refresh-69 spin" : "now-ui-icons business_money-coins"}
            />
          </Col>
        </Row>
      </Form>
    );
  }
  createOrdersTable() {
    let result = null;

    if (this.props.bills && Object.keys(this.props.bills).length > 0) {
      result = (
        <Table responsive className="styled-table">
          <thead>
            <tr className="text-primary">
              {thead.map((prop, key) => {
                if (prop === "Devolución") return null;
                if (prop === "Total") {
                  return [
                    <th key={"items"} className="text-center">{"Items"}</th>,
                    <th key={key} className="text-center">{prop}</th>
                  ];
                } else {
                  if (!this.props.showCustomer && prop === "Cliente") return null;
                  return <th key={key} className="text-center">{prop}</th>;
                }
              })}
            </tr>
          </thead>
          <tbody>
            {Object.keys(this.props.bills).sort((a,b)=>b-a).map(order_id => {
              let order = this.props.bills[order_id];
              let currentCustomerLink = null;
              // if (order.cliente_id in this.props.mainState.customers) {
              // currentCustomer = this.props.mainState.customers[order.cliente_id][0];
              if (this.props.showCustomer) {
                currentCustomerLink = (
                  <Link to={"/clientes/fichas/".concat(order.cliente_id)}>
                    {order.nombre} {order.primer_apellido} {order.segundo_apellido}
                  </Link>
                );
              }
              let overcharge = "";
              // if (!Array.isArray(order.fecha_devolucion)) {
              //   overcharge = <span style={{color:"#e74c3c"}}><b> (+5€)</b></span>;
              // }
              // if (!Array.isArray(order.fecha_pago_devolucion)) {
              //   overcharge = <span style={{color:"#e74c3c"}}><b> (+5€)</b></span>;
              // }
              if (order.devuelta) overcharge = <span style={{color:"#e74c3c"}}><b> (+5€)</b></span>;
              let remaining = null;
              if (order.remaining_100 > 0 && order.remaining_amount !== "") {
                remaining = "debe " + order.remaining_amount;
              }
              let unpaid_date = "";
              // if (this.state.currentPill === PILL_DEVUELTAS) {
              try {
                unpaid_date = order.fecha_devolucion ? order.fecha_devolucion.replace(/-/g,'/').split(" ")[0] : "";
              } catch (error) {
                unpaid_date = JSON.stringify(order.fecha_devolucion);
              }
              // console.log("unpaid_date", unpaid_date);
              let registerPaymentButton = null;
              if (/*order.pendiente &&*/ this.props.userData.isBillingDepartment()) {
                registerPaymentButton = (
                  <Button
                    color="warning"
                    size="sm"
                    // disabled={!this.validateRegisterPayment() || this.state.registeringPayment}
                    onClick={() => {
                      let registerPayment = this.state.registerPayment;
                      if (registerPayment === order_id) {
                        registerPayment = null;
                      } else {
                        registerPayment = order_id;
                      }
                      this.setState({ 
                        registerPayment: registerPayment,
                        showNotes: null, 
                        showItems: null,
                        registerPaymentAmount: null,
                        registerPaymentConcept: null
                      });
                    }}
                    leftLabel={"now-ui-icons business_money-coins"}
                  />
                );
              }
              let items = (
                <Button
                  color="default"
                  size="sm"
                  style={{
                    display: "block",
                    width: "100%"
                  }}
                  onClick={() => {
                    // if (order.line_items.line_items) {
                      let showItems = this.state.showItems;
                      if (showItems === order_id) {
                        showItems = null;
                      } else {
                        showItems = order_id;
                      }
                      this.setState({ registerPayment: null, showNotes: null, showItems: showItems });
                    // }
                  }}
                  leftLabel={"now-ui-icons shopping_box"}
                >
                  {order ? (order.line_items ? order.line_items.count : "") : ""}
                </Button>
              );
              let notes = (
                <Button
                  color={order.notes && order.notes.count > 0 ? "info" : "default"}
                  size="sm"
                  onClick={() => {
                    // if (order.notes && order.notes.notes) {
                      let showNotes = this.state.showNotes;
                      if (showNotes === order_id) {
                        showNotes = null;
                      } else {
                        showNotes = order_id;
                      }
                      this.setState({ registerPayment: null, showNotes: showNotes, showItems: null });
                    // }
                  }}
                  leftLabel={"now-ui-icons ui-2_chat-round"}
                >
                  {order.notes && order.notes.count > 0 ? order.notes.count : ""}
                </Button>
              );
              // }
              let isThisSelectedOrder = (this.state.showItems === order_id) || (this.state.showNotes === order_id) || (this.state.registerPayment === order_id);
              let isAnySelectedOrder = (this.state.showItems !== null) || (this.state.showNotes !== null) || (this.state.registerPayment !== null);
              let currentOrderTr = (
                <tr key={order.numero_pedido} className={isThisSelectedOrder ? "show-line-items active-row" : (isAnySelectedOrder ? "background-row" : "")}>
                  <td className="text-center">
                    {order.fecha}
                    {unpaid_date && unpaid_date !== "" && unpaid_date !== '[""]' ? (<span><br /><span className="item-related unpaid-date"><i className="now-ui-icons design_scissors" /> {unpaid_date}</span></span>) : null}
                  </td>
                  {this.props.showCustomer && <td className="text-center">{currentCustomerLink}</td>}
                  <td className="text-center">{order.numero_pedido}</td>
                  <td className="text-center">{items}</td>
                  <td className="text-center">{order.total}{overcharge}
                    {remaining ? (<span><br /><span className="item-related"> {remaining}</span></span>) : null}
                  </td>
                  <td className="text-center">{this.paymentStatus(order)}</td>
                  <td className="text-center">
                    {registerPaymentButton}{" "}
                    {notes}{" "}
                    <Button
                      color="danger"
                      size="sm"
                      onClick={e =>
                        this.downloadBill(order.enlace_pdf, order.numero_pedido, e)
                      }
                    >
                      {this.downloadButton(order.numero_pedido)}
                    </Button>{" "}
                    {this.getViewArticlesButton(order.numero_pedido)}
                  </td>
                </tr>
              );
              // console.log("currentOrderTr", currentOrderTr);
              let colSpan = currentOrderTr.props.children.length - 1;
              if (!this.props.showCustomer) colSpan -= 1;
              if (this.state.showItems === order_id) {
                let itemsTr = null;
                if (!order.line_items.loaded) {
                  if (!this.props.userData.mainState.isGettingOrder) this.props.reloadEntityCallback(order_id);
                  itemsTr = (
                    <tr>
                      <td className="text-left">
                        <div className="text-center">
                          <i className="now-ui-icons arrows-1_refresh-69 spin" />{" Cargando items..."}
                        </div>
                      </td>
                    </tr>
                  );
                }else {
                  itemsTr = Object.keys(order.line_items.line_items).sort((a,b)=>b-a).map(item_id => {
                    let item = order.line_items.line_items[item_id];
                      return (
                        <tr key={order.numero_pedido + "-line_items-" + item_id}>
                          {/* <td className="text-left">{item.related}</td> */}
                          <td className="text-left">
                            <span className="item-name">{item.replaced_name}</span>
                            {item.related  && item.related !== "" ? (<span><br /><span className="item-related">{item.related}</span></span>) : null}
                          </td>
                          <td className="text-right">{item.total}</td>
                        </tr>
                      );
                  });
                }
                let itemsTable = (
                  <Table id="items-inside-orders" className="line-items-table styled-table">
                    {/* <thead>
                      <tr>
                        <th className="text-left">Relacionado</th>
                        <th className="text-left">Nombre</th>
                        <th className="text-right">Precio</th>
                      </tr>
                    </thead> */}
                    <tbody>{itemsTr}</tbody>
                  </Table>
                );
                let closeItemsButton = (
                  <Button
                    color="default"
                    size="sm"
                    style={{
                      display: "block",
                      width: "100%"
                    }}
                    onClick={() => {
                      this.setState({ showItems: null });
                    }}
                    leftLabel={"now-ui-icons ui-1_simple-remove"}
                  >
                    {"Cerrar"}
                  </Button>
                );
                let itemsTableInTr = (
                  <tr key={order.numero_pedido + "-line_items"} className="line-items-tr">
                    <td colSpan={colSpan}>{itemsTable}</td>
                    <td style={{ display: "block" }}>{closeItemsButton}</td>
                  </tr>
                );
                return [currentOrderTr, itemsTableInTr, <tr key="tr-keep-odd-even"></tr>];
              } else if (this.state.showNotes === order_id) {
                // console.log("En mostrar notas", this.state);
                // console.log("En mostrar notas -> order", order);
                let closeNotesButton = (
                  <Button
                    color="default"
                    size="sm"
                    style={{
                      display: "block",
                      width: "100%"
                    }}
                    onClick={() => {
                      this.setState({ showNotes: null });
                    }}
                    leftLabel={"now-ui-icons ui-1_simple-remove"}
                  >
                    {"Cerrar"}
                  </Button>
                );
                let notesContent = order.notes ? this.createNotesContent(order.notes) : null;
                let notesTr = (
                  <tr key={order.numero_pedido + "-line_items"} className="line-items-tr">
                    <td colSpan={colSpan}>{notesContent}</td>
                    <td style={{ display: "block" }}>{closeNotesButton}</td>
                  </tr>
                );
                return [currentOrderTr, notesTr, <tr key="tr-keep-odd-even"></tr>];
              } else if (this.state.registerPayment === order_id) {
                // console.log("En mostrar notas", this.state);
                // console.log("En mostrar notas -> order", order);
                let closeButton = (
                  <Button
                    color="default"
                    size="sm"
                    style={{
                      display: "block",
                      width: "100%"
                    }}
                    onClick={() => {
                      this.setState({ registerPayment: null });
                    }}
                    leftLabel={"now-ui-icons ui-1_simple-remove"}
                  >
                    {"Cerrar"}
                  </Button>
                );
                let subContent = this.createRegisterPayment();//this.createNotesContent(order.notes);
                let subTr = (
                  <tr key={order.numero_pedido + "-line_items"} className="line-items-tr">
                    <td colSpan={colSpan}>{subContent}</td>
                    <td style={{ display: "block" }}>{closeButton}</td>
                  </tr>
                );
                return [currentOrderTr, subTr, <tr key="tr-keep-odd-even"></tr>];
              } else {
                return currentOrderTr;
              }
            })}
          </tbody>
        </Table>
      );
    } else {
      result = (
      <LoadingCard style={{ width: "100%", marginTop: 16 }} loading={true}>
      </LoadingCard>
        // <div className="text-center">
        //   <i className="now-ui-icons arrows-1_refresh-69 spin" />{" Cargando facturas..."}
        // </div>
      );
    }

    // result = (
    //   <Col xs={12}>
    //     <h5>Facturas</h5>
    //     {result}
    //     {/* <Card>
    //       <CardHeader>
    //       </CardHeader>
    //       <CardBody>
    //       </CardBody>
    //     </Card> */}
    //   </Col>
    // );
    return <div>
      {this.state.showPopUp && this.createPopUp()}
      {result}
    </div>;
  }
  render() {
    let contentToDisplay = this.createOrdersTable();
    return contentToDisplay;
  }
}

BillsTable.propTypes = {
  showCustomer: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  bills: PropTypes.oneOfType([PropTypes.array, PropTypes.array]),
  reloadEntityCallback: PropTypes.func,
  userData: PropTypes.object
};

export default BillsTable;



// WEBPACK FOOTER //
// ./src/components/Bills/BillsTable.jsx